import { createSmartrrModal } from "@vendor-app/utils/createModalStore";

import { ISequentialFlowModalProps } from ".";

export const useSequentialFlowModalStore = createSmartrrModal<ISequentialFlowModalProps>();
